import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@mui/material';
import { fetchBulkUploadRequest } from '../../../api/bulkUpload/bulkUploadSlice';
import useSubscriptionCheck from '../../common/SubscriptionCheck';
import { useNavigate } from 'react-router-dom';
import BulkUploadButtonAction from '../../bulkUpload/components/BulkUploadButtonAction';

function DraftDocumentListPageActions() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const { checkSubscription, SubscriptionModal } = useSubscriptionCheck();

  const handleOpen = () => {
    if (!checkSubscription()) {
      return;
    }
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    dispatch(fetchBulkUploadRequest({ query: { page: 1, limit: 10 } }));
    navigate('/drafts');
  };

  return (
    <>
      <Button variant="contained" color="primary" onClick={handleOpen}>
        + Bulk Upload
      </Button>
      <BulkUploadButtonAction open={open} onCancel={handleClose} document_type="consolidated" />
      <SubscriptionModal />
    </>
  );
}

export default DraftDocumentListPageActions;
